import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { PortalAppointmentService } from "../../services/portal/PortalAppointmentService";
import { usePortalStore } from "../../store/portal/PortalStoreContext";
const LIST_STALE_MS = 30 * 1000;
export const portalKeys = {
    all: ["medos", "portal"],
    appointments: () => [...portalKeys.all, "appointments"],
    appointmentList: (identity, scope) => [...portalKeys.appointments(), identity, scope],
    packs: (identity, addressId) => [...portalKeys.all, "packs", identity, addressId],
};
export function usePortalIdentityKey() {
    const channel = usePortalStore((s) => s.channel);
    const countryCode = usePortalStore((s) => s.countryCode);
    const phoneNumber = usePortalStore((s) => s.phoneNumber);
    const email = usePortalStore((s) => s.email);
    return channel === "email"
        ? `email:${email.trim()}`
        : `phone:${countryCode}${phoneNumber}`;
}
export function useMyAppointmentsQuery(scope) {
    const verified = usePortalStore((s) => s.view !== "phone" && s.view !== "code");
    const identity = usePortalIdentityKey();
    return useQuery({
        queryKey: portalKeys.appointmentList(identity, scope ?? "ALL"),
        queryFn: () => PortalAppointmentService.listMine({
            patientId: scope === "ALL" ? null : scope,
        }),
        enabled: verified && scope !== null,
        staleTime: LIST_STALE_MS,
        retry: 1,
        refetchOnWindowFocus: false,
    });
}
export function useInvalidatePortalAppointments() {
    const queryClient = useQueryClient();
    return () => queryClient.invalidateQueries({ queryKey: portalKeys.appointments() });
}
export function usePortalSignOut() {
    const queryClient = useQueryClient();
    const signOut = usePortalStore((s) => s.signOut);
    return useCallback(() => {
        queryClient.clear();
        signOut();
    }, [queryClient, signOut]);
}
